module.exports = __webpack_public_path__ + "static/media/default.62c0ac55.sf2";